import * as types from './types'

export default {
  [types.SET_TECHNICIANS](state, data) {
    state.technicians = data
  },
  [types.SET_WORKORDER](state, workOrder) {
    state.workOrder = workOrder
  },
  [types.INIT_WORKORDER](state) {
    state.workOrder = {
      Id: 0,
      Location: {
        Id: 0,
        Name: ''
      },
      WorkOrder: {
        CreatedBy: {
          Id: 0,
          LastName: '',
          FirstName: ''
        },
        UpdatedBy: {
          Id: 0,
          LastName: '',
          FirstName: ''
        }
      },
      ScanReport: {
        Status: '',
        CreatedBy: {
          Id: 0,
          LastName: '',
          FirstName: ''
        },
        UpdatedDate: new Date(),
        UpdatedBy: {
          Id: 0,
          LastName: '',
          FirstName: ''
        }
      },
      Invoice: {
        Number: '',
        Amount: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenance/mutations.js